export const DIRECTION = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical"
};
export type DIRECTION = typeof DIRECTION[keyof typeof DIRECTION];
